import * as React from 'react';
import { BookButtonContainer } from '../BookButtonContainer';
import { useSelector } from 'react-redux';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';
import { ChatButtonContainer } from '../ChatButtonContainer';

import * as styles from './OnlineBookingCardActionsContainer.css';
import { trackOnlineBookingBookButton } from './tracking';

interface IOnlineBookingCardActionsContainerProps {
  offerId: number;
  position: number;
}

export const OnlineBookingCardActionsContainer: React.FC<IOnlineBookingCardActionsContainerProps> = ({
  offerId,
  position,
}) => {
  const offer = useSelector(selectRecommendationById(offerId));
  const { url = '' } = offer || {};

  const onBookButtonClick = React.useCallback(() => {
    trackOnlineBookingBookButton(offerId, position);
  }, [offerId, position]);

  return (
    <div className={styles['root']}>
      <div className={styles['book-button']}>
        <BookButtonContainer url={url} canBeBooked={false} onClick={onBookButtonClick} />
      </div>
      <ChatButtonContainer offerId={offerId} type="short" />
    </div>
  );
};
